// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_NJh","cls2":"common-cls2_eW3 common-cls1_NJh"};